import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Slider from "react-slick";

import ProductBanner from './ProductBanner';
import ImageBanner from './ImageBanner';
import ElementBanner from './ElementBanner';

import { getCompanyPromoMaterial } from '../../redux/actions/companyPromoMaterialActions';

const PageBanner = (props) => {

    var bannerList = [];

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getCompanyPromoMaterial());
    }, []);

    const getUserBanner = useSelector((state) => state.getUserBanner.items);

    if (props.categoryType == 'brend') {
        bannerList = getUserBanner.filter(x => x.acDept == props.categoryId);
    } else if (props.pageId != 0) {
        bannerList = getUserBanner.filter(x => x.anPageKey == props.pageId);
    } else {
        bannerList = getUserBanner.filter(x => x.anCategoryKey == props.categoryId);
    }

    return (
        <>
            {Object.keys(bannerList).length != 0 && (
                <>
                    {bannerList[0].acBannerType == 0 && <ImageBanner pageId={props.pageId} categoryId={props.categoryId} />}
                    {bannerList[0].acBannerType == 1 && <ProductBanner item={bannerList[0]} />}
                    {bannerList[0].acBannerType == 2 && <ElementBanner pageId={props.pageId} item={bannerList[0]} />}
                </>
            )}
        </>
    )
};

export default PageBanner;
